/**
 * Generated by orval v7.13.0 🍺
 * Do not edit manually.
 * My App
 * This is an awesome app!
 * OpenAPI spec version: 1.0.0
 */
import type {
  AccessDeniedErrorResponse,
  BadRequestErrorResponse,
  BookingGuestCardApiResource,
  GetApiBookingGuestCardsList200,
  GetApiBookingGuestCardsListParams,
  RegisterGuestCardRequest,
  UnauthorizedErrorResponse
} from '.././models';

import { customFetch } from '../../custom-fetch';

export type getApiBookingGuestCardsListResponse200 = {
  data: GetApiBookingGuestCardsList200
  status: 200
}

export type getApiBookingGuestCardsListResponse401 = {
  data: UnauthorizedErrorResponse
  status: 401
}

export type getApiBookingGuestCardsListResponse403 = {
  data: AccessDeniedErrorResponse
  status: 403
}
    
export type getApiBookingGuestCardsListResponseSuccess = (getApiBookingGuestCardsListResponse200) & {
  headers: Headers;
};
export type getApiBookingGuestCardsListResponseError = (getApiBookingGuestCardsListResponse401 | getApiBookingGuestCardsListResponse403) & {
  headers: Headers;
};

export type getApiBookingGuestCardsListResponse = (getApiBookingGuestCardsListResponseSuccess | getApiBookingGuestCardsListResponseError)

export const getGetApiBookingGuestCardsListUrl = (id: string,
    params?: GetApiBookingGuestCardsListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/bookings/${id}/guest-cards?${stringifiedParams}` : `/api/bookings/${id}/guest-cards`
}

export const getApiBookingGuestCardsList = async (id: string,
    params?: GetApiBookingGuestCardsListParams, options?: RequestInit): Promise<getApiBookingGuestCardsListResponse> => {
  
  return customFetch<getApiBookingGuestCardsListResponse>(getGetApiBookingGuestCardsListUrl(id,params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}


export type postApiBookingGuestCardRegisterResponse201 = {
  data: BookingGuestCardApiResource
  status: 201
}

export type postApiBookingGuestCardRegisterResponse400 = {
  data: BadRequestErrorResponse
  status: 400
}

export type postApiBookingGuestCardRegisterResponse401 = {
  data: UnauthorizedErrorResponse
  status: 401
}

export type postApiBookingGuestCardRegisterResponse403 = {
  data: AccessDeniedErrorResponse
  status: 403
}
    
export type postApiBookingGuestCardRegisterResponseSuccess = (postApiBookingGuestCardRegisterResponse201) & {
  headers: Headers;
};
export type postApiBookingGuestCardRegisterResponseError = (postApiBookingGuestCardRegisterResponse400 | postApiBookingGuestCardRegisterResponse401 | postApiBookingGuestCardRegisterResponse403) & {
  headers: Headers;
};

export type postApiBookingGuestCardRegisterResponse = (postApiBookingGuestCardRegisterResponseSuccess | postApiBookingGuestCardRegisterResponseError)

export const getPostApiBookingGuestCardRegisterUrl = (id: string,) => {


  

  return `/api/bookings/${id}/guest-card`
}

export const postApiBookingGuestCardRegister = async (id: string,
    registerGuestCardRequest: RegisterGuestCardRequest, options?: RequestInit): Promise<postApiBookingGuestCardRegisterResponse> => {
  
  return customFetch<postApiBookingGuestCardRegisterResponse>(getPostApiBookingGuestCardRegisterUrl(id),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      registerGuestCardRequest,)
  }
);}


